// extracted by mini-css-extract-plugin
export default {"priceRating":"price-rating_priceRating__2tQre","fadedPrice":"price-rating_fadedPrice__1fOJj"};